import { Activity } from "./Activity";
export class ChatActivity extends Activity {
    constructor(isCompleted, title, points, src, events) {
        super();
        this.isCompleted = isCompleted;
        this.title = title;
        this.points = points;
        this.src = src;
        this.events = events;
    }
    getChatEventByNodeId(nodeId) {
        return this.events.find(({ onNodeAdded }) => onNodeAdded.includes(nodeId));
    }
}
